module.exports = __webpack_public_path__ + "img/lg_ring_g_c_null_null@3x.d87fa256.png";